import store from "@/store";
import request from "@/utils/request";


export async function getMomentdayList(params) {
    console.log("@@ get list : getMomentdayList");
    let result = request.get("/api/moment/momentday/",{params});
    return result;
}

export async function setMomentdayList(params) {
    console.log("@@ get list : setMomentdayList");
    let result = request.post("/api/moment/momentday/save/",params);
    return result;
}

export async function setMomentdayListOrderNum(params) {
    console.log("@@ get list : setMomentdayListOrderNum");
    let result = request.post("/api/moment/momentCont/",params);
    return result;
}

export async function deleteMomentDay(hdaySeq) {
    console.log("@@ delete : deleteMomentDay");
    const params = {hdaySeq:hdaySeq};
    const config = {params:params};
    const result = request.delete(`/api/moment/momentday/`, config);
    return result;
}
